var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutorecenteron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    id: "svg_8",
    d: "m59.2575,65.46653l9.99999,-9.96641l10,9.96641l-5,0l0,10.01436l-9.99999,0l0,-10.01436l-5,0z",
    strokeWidth: 0,
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000",
    id: "svg_9",
    height: 7,
    width: 40,
    y: 46.5,
    x: 48,
    strokeWidth: 0,
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 69.2575 35.4905)",
    stroke: "#000",
    id: "svg_14",
    d: "m59.2575,35.46653l9.99999,-9.96641l10,9.96641l-5,0l0,10.01437l-9.99999,0l0,-10.01437l-5,0z",
    strokeWidth: 0,
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(2.3334 0 0 2.59991 -13.5942 -41.8533)",
    stroke: "#000",
    fontWeight: "bold",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "'Cabin'",
    fontSize: 24,
    id: "svg_15",
    y: 44.11521,
    x: 11,
    strokeWidth: 0,
    fill: "#00bf00"
  }, "A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorecenteron);
export default __webpack_public_path__ + "static/media/autorecenteron.da84b485d7e59353df54e6fd99a922cd.svg";
export { ForwardRef as ReactComponent };